import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { switchMap } from 'rxjs/operators';


interface Groups{
  groups: Group[];
  answers:  { [key: number]: any[] };
  optionTextAnswers: { [key: number]: string };
}

export interface Group{
  name: string;
  order: number;
  questions: Question[];
}

export interface Question {
  id: number;
  text: string;
  description?: string;
  display_order: number;
  active: boolean;
  multi_answer: boolean;
  text_value_answer: boolean;
  options: Option[];
}

export interface Option {
  id: number;
  text: string;
  description?: string;
  display_order: number;
  active: boolean;
  question_id: number;
  exclusive: boolean;
  allow_text_value: boolean;
}

export interface Answer {
  question_id: number;
  peopleid: String;
  option_ids: any[];
  text_value?: string;
  text_value_option_id?: number;
}

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, ) {}

  getQuestions(peopleId: String, journal: string, questionnaireId: string): Observable<Groups> {
    //console.log('Calling API: ', `${this.apiUrl}/questions/${peopleId}/${journal}/${questionnaireId}`);
    return this.http.get<Groups>(`${this.apiUrl}/questions/${peopleId}/${journal}/${questionnaireId}`);
  }


  submitAnswersAndSaveAttempt(
        answers: Answer[],
        peopleId: string,
        journal: string,
        questionnaireId: string,
        prefer_not_answer: boolean
      ): Observable<any> {

    return this.submitAnswers(answers, questionnaireId).pipe(
      switchMap(() =>
        this.saveAttempt(
          peopleId,
          journal,
          questionnaireId,
          prefer_not_answer
        )
      )
    );
  }


  submitAnswers(answers: Answer[], questionnaireId: string): Observable<any> {
    return this.http.post<HttpResponse<any>>(`${this.apiUrl}/submit`, { answers, questionnaireId }, {observe: 'response'});
  }

  healthCheck(): Observable<any> {
    return this.http.get<HttpResponse<any>>(`${this.apiUrl}/health`, { observe: 'response' });
  }

  saveAttempt(peopleId: String, journal: string, questionnaireId: String, prefer_not_answer: boolean): Observable<any>{
    let attempt = {
      'peopleid': peopleId,
      'journal': journal,
      'questionnaireId': questionnaireId,
      'prefer_not_answer': prefer_not_answer
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<HttpResponse<any>>(`${this.apiUrl}/save_attempt`, { attempt }, {observe: 'response', headers: headers});
  }
}
